import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewContainerRef,
  ViewEncapsulation,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { Subject, takeUntil } from "rxjs";
import { HeaderTextService } from "./header-text.service";
import { Router } from '@angular/router';
import { TitleType } from "./header-text.types";

@Component({
  selector: "header-text",
  templateUrl: "./header-text.component.html",
  encapsulation: ViewEncapsulation.None,
  exportAs: "headerText",
  standalone: true,
  imports: [CommonModule]
})
export class HeaderTextComponent implements OnInit, OnDestroy {

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    public _headerTextService: HeaderTextService,
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
  }

  getTitulo() {
    let titulo = this._headerTextService.getTitulo();
    let nombre = this._headerTextService.getNombre();
    let subtitulo = this._headerTextService.getNombre();

    if (nombre) {
      return nombre;
    }

    if (titulo.includes("/detalles-deuda")) {//para los casos en que la url tiene siempre algo distinto al final(por ejemplo un id)
      return TitleType.find((title) => title.path.includes("/detalles-deuda")).text;
    }
    if (titulo.includes("/por-complejo")) {
      return TitleType.find((title) => title.path.includes("/por-complejo")).text;
    }
    if (titulo.includes("/pedido-reserva")) {
      return TitleType.find((title) => title.path.includes("/pedido-reserva")).text;
    }
    if (titulo.includes("/reserva-pedido")) {
      return TitleType.find((title) => title.path.includes("/reserva-pedido")).text;
    }
    if (titulo.includes("/por-inquilino")) {
      return TitleType.find((title) => title.path.includes("/por-inquilino")).text;
    }
    if (titulo.includes("/cuotas/comprobantes-asociados")) {
      return TitleType.find((title) => title.path.includes("/cuotas/comprobantes-asociados")).text;
    }
    if (titulo && titulo.includes("/valor-alquileres/detalle-alquiler")) {
      const baseTitle = TitleType.find((title) => title.path.includes("/valor-alquileres/detalle-alquiler")).text;
      return subtitulo ? `${subtitulo}` : baseTitle;
    }
    if (titulo && titulo.includes("/dashboard/editar-captacion")) {
      const baseTitle = TitleType.find((title) => title.path.includes("/dashboard/editar-captacion")).text;
      return subtitulo ? `${subtitulo}` : baseTitle;
    }
    if (titulo && titulo.includes("/dashboard/editar-demanda")) {
      const baseTitle = TitleType.find((title) => title.path.includes("/dashboard/editar-demanda")).text;
      return subtitulo ? `${subtitulo}` : baseTitle;
    }
    if (titulo && titulo.includes("/valor-alquileres/detalle/alquiler")) {
      const baseTitle = TitleType.find((title) => title.path.includes("/valor-alquileres/detalle/alquiler")).text;
      return subtitulo ? `${subtitulo}` : baseTitle;
    }
    if (titulo && titulo.includes("/complejo")) {
      const baseTitle = TitleType.find((title) => title.path.includes("/complejo")).text;
      return subtitulo ? `${subtitulo}` : baseTitle;
    }
    return TitleType.find((title) => title.path === titulo)?.text;
  }

  getPath() {
    return this._headerTextService.getTitulo() != "/" ? this._headerTextService.getTitulo() : "";
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
